export function reloadOffersRoute(location: Pick<Location, "reload">): void {
  location.reload();
}
